import React from 'react';
import PropTypes from 'prop-types';
import TableCell from './TableCell';

const TableRow = props => (
    <tr className="ui-table__row">
        {props.columns.map((colData) => {
            if (colData.customCell) {
                const CustomCell = colData.customCell.component
                    ? colData.customCell.component
                    : colData.customCell;

                return (
                    <TableCell key={colData.columnName} {...colData}>
                        <CustomCell rowData={props.children} {...colData} />
                    </TableCell>
                );
            }

            return (
                <TableCell key={colData.columnName} {...colData}>
                    {props.children[colData.columnName]}
                </TableCell>
            );
        })}
    </tr>
);

TableRow.propTypes = {
    children: PropTypes.object,
    columns: PropTypes.array
};

export default TableRow;



// WEBPACK FOOTER //
// ./src/js/modules/DataTable/components/TableRow.js